import { Component, effect, inject, OnDestroy, OnInit, signal } from "@angular/core";
import { LiveUpdateService } from "../../../../../../../shared/src/lib/services/live-update.service";
import { ActivatedRoute } from "@angular/router";
import { MatExpansionModule } from "@angular/material/expansion";
import { JsonPipe } from "@angular/common";
import { MarketService } from "../../../../../../../shared/src/lib/services/market.service";
import { WebsocketService } from "../../../../../../../shared/src/lib/services/websocket.service";
import { Subject } from "rxjs";
import { MarketOpsService } from "../../market-layout/market/market-ops.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-market-update-debugger",
  imports: [MatExpansionModule, JsonPipe],
  templateUrl: "./market-update-debugger.component.html",
  styleUrl: "./market-update-debugger.component.scss",
})
export class MarketUpdateDebuggerComponent implements OnInit, OnDestroy {
  readonly destroy$ = new Subject<void>();
  liveUpdateService = inject(LiveUpdateService);
  marketService = inject(MarketService);
  wsService = inject(WebsocketService);
  marketOps = inject(MarketOpsService);
  mId = signal<any>("");
  activatedRoute = inject(ActivatedRoute);
  marketUpdate = signal<any[]>([]);
  runners: any = {};
  market: any = null;

  constructor() {
    effect(() => {
      if (!this.mId()) return;
      const data = this.liveUpdateService._getData("market", {
        field: "id",
        value: this.mId(),
      });
      if (data) {
        this.handleMarketUpdate(data);
      }
    });
  }

  ngOnInit() {
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.mId.set(params["marketId"]);
      this.getMarketSnapshot(params["marketId"]);
      this.getMarket(params["marketId"]);
    });
    this.initConnection();
    this.getConnectionStatus();
  }

  initConnection() {
    this.wsService
      .startConnection()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (message) => {
          if (message === true) return;

          this.liveUpdateService.setData(message);
          this.liveUpdateService._setData(message);
        },
        error: (error) => console.log("WebSocket error:", error),
      });
  }

  getConnectionStatus() {
    this.wsService.connectionStatus.pipe(takeUntil(this.destroy$)).subscribe({
      next: (status) => {
        if (status) {
          this.wsService.sendMessage({ topics: [`bf_${this.mId()}`] });
        }
      },
    });
  }

  handleMarketUpdate(update: any) {
    this.marketUpdate.set(update?.r);
  }

  get missingHandicaps() {
    const runners = this.marketUpdate();
    const missingHandicaps: any[] = [];
    this.market?.runners?.forEach((runner: any) => {
      const { handicap } = runner;
      const handicapExists = runners?.some((r: any) => r?.ex?.hc === handicap);
      // console.log("Handicap from market", handicap, "Handicap exists", handicapExists);
      if (!handicapExists && !missingHandicaps.includes(handicap)) {
        missingHandicaps.push(handicap);
      }
    });

    return missingHandicaps;
  }

  getMarket(id: string) {
    this.marketService
      .fetchMarket({ id })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data) {
            this.market = response?.data;
            const { runners } = response?.data || {};
            if (runners?.length > 0) {
              this.runners = runners.reduce(
                (acc: any, runner: any) => {
                  if (!acc[runner.selectionId]) {
                    acc[runner.selectionId] = runner;
                  }
                  return acc;
                },
                {} as Record<number, any>,
              );
            }
          }
        },
      });
  }

  getMarketSnapshot(id: string) {
    const qParams = { market_ids: `bf_${id}`, statuses: "2,3", return_snapshot: "Y" };
    this.marketService
      .fetchMarketStatus(qParams)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response) {
            const { snapshot } = response || {};
            this.marketUpdate.set(snapshot[`bf_${id}`]?.r);
          }
        },
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
